import { useEffect, FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';

import { Loader } from '../Loader';

import playAudio from '~frontend/utils/playAudio';

import { useGetWheelPrizes, usePrizes, useWinGame } from './hooks';

import _ from 'lodash';

const Prizes: FunctionComponent = () => {
  const [, setPrizes] = usePrizes();
  const [, setWinGame] = useWinGame();
  const {
    i18n: { language },
  } = useTranslation();

  const { loading, error, data } = useGetWheelPrizes();

  useEffect(() => {
    if (data) {
      const prizes = _.take(_.shuffle(data.getWheelPrizes), 12);

      setPrizes(prizes);
    }
  }, [data, setPrizes, setWinGame]);

  if (loading) {
    return <Loader />;
  } else if (error) {
    return <>GetWheelPrizes | Error! {error.message}</>;
  }

  const { getWheelPrizes } = data;

  return (
    <>
      {_.map(getWheelPrizes, (prize) => (
        <div
          className="bonus-prizes-item"
          data-rar={prize.color}
          key={prize.id}
          onMouseEnter={playAudio}
          data-audio="5.wav"
          data-volume="0.4"
        >
          {/* {prize?.getChance > 0 && (
            <div className="drop-chance">{prize?.getChance}%</div>
          )} */}
          <img src={prize.image} alt="" />
          <div className="bonus-prizes-item-name">{prize.name[language]}</div>
        </div>
      ))}
    </>
  );
};

const PrizesView: FunctionComponent = () => {
  const { t } = useTranslation();
  return (
    <>
      <div className="bonus-prizes-title">{t('wheel_prizes')}</div>

      <div className="bonus-prizes-wrap">
        <Prizes />
      </div>
    </>
  );
};

export default PrizesView;
